import { Controller } from "@hotwired/stimulus"

const CALENDAR_BREAKPOINT = "(min-width: 768px)"

export default class extends Controller {
  static values = {
    reminderIds: Array,
    agendaReminderIds: Array,
    gridReminderIds: Array,
    surface: String,
    url: String,
  }

  initialize() {
    this.handleBreakpointChange = this.handleBreakpointChange.bind(this)
    this.submittedReminderIds = new Set()
  }

  connect() {
    this.calendarBreakpoint = this.calendarBreakpointForSurface()
    this.calendarBreakpoint?.addEventListener("change", this.handleBreakpointChange)
    this.recordActiveReminders()
  }

  disconnect() {
    this.calendarBreakpoint?.removeEventListener("change", this.handleBreakpointChange)
    this.calendarBreakpoint = null
  }

  handleBreakpointChange() {
    this.recordActiveReminders()
  }

  recordActiveReminders() {
    const reminderIds = this.activeReminderIds().filter(
      (reminderId) => !this.submittedReminderIds.has(reminderId)
    )
    if (reminderIds.length === 0) return

    reminderIds.forEach((reminderId) => this.submittedReminderIds.add(reminderId))
    this.recordDisplay(reminderIds)
  }

  activeReminderIds() {
    if (this.surfaceValue !== "cooking_calendar") return this.reminderIdsValue

    return this.calendarBreakpoint?.matches
      ? this.gridReminderIdsValue
      : this.agendaReminderIdsValue
  }

  calendarBreakpointForSurface() {
    if (this.surfaceValue !== "cooking_calendar") return null

    return window.matchMedia(CALENDAR_BREAKPOINT)
  }

  recordDisplay(reminderIds) {
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    }
    if (csrfToken) headers["X-CSRF-Token"] = csrfToken

    fetch(this.urlValue, {
      method: "POST",
      credentials: "same-origin",
      headers,
      body: JSON.stringify({
        reminder_ids: reminderIds,
        surface: this.surfaceValue,
      }),
    }).catch(() => {})
  }
}
